module.exports = __webpack_public_path__ + "img/interaction-movie.99c1580e.png";